
import { defineComponent, ref, onMounted } from 'vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import KyuyohiMeisaiItemSetting from '@/views/fuzoku-meisai/junsoku/KyuyohiMeisaiItemSetting.vue'
import { ResponseSettingItem } from '@/repositories/fuzoku-meisai/data'
import { ResponseKyuyohiSetting, ResponseKyuyohiSettingDetail } from '@/repositories/fuzoku-meisai/junsoku/data'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { junsokuRepositories } from '@/repositories/fuzoku-meisai/junsoku/junsokuRepositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import JunsokuSettingTitle from '@/views/fuzoku-meisai/junsoku/JunsokuSettingTitle.vue'

const repository = junsokuRepositories.kyuyohi

const emptySettingItem: ResponseSettingItem = {
  sources: [],
  targets: []
}

const emptyDetail: ResponseKyuyohiSettingDetail = {
  doctor: emptySettingItem,
  nurse: emptySettingItem,
  therapist: emptySettingItem,
  technician: emptySettingItem,
  clerk: emptySettingItem,
  skilledLaborer: emptySettingItem,
  other: emptySettingItem
}

const emptySetting: ResponseKyuyohiSetting = {
  kyuryou: emptyDetail,
  shouyo: emptyDetail,
  shouyoHikiate: emptyDetail,
  taishoku: emptyDetail,
  fukuri: emptySettingItem
}

export default defineComponent({
  components: {
    JunsokuSettingTitle,
    ResponseResultAlert,
    SettingPanel,
    KyuyohiMeisaiItemSetting,
    ContentLayout,
    LoadingButton
  },
  setup () {
    const loading = ref(false)
    const isSucceedRequest = ref(false)
    const requestError = ref<string | null>(null)
    const settings = ref<ResponseKyuyohiSetting>(emptySetting)

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        settings.value = await repository.list()
      })
      loading.value = false
    })

    const onUpdateTab = (idPrefix: string, detail: ResponseKyuyohiSettingDetail) => {
      switch (idPrefix) {
        case 'kyuyo':
          settings.value.kyuryou = detail
          break
        case 'shouyo':
          settings.value.shouyo = detail
          break
        case 'shouyo-hikiate':
          settings.value.shouyoHikiate = detail
          break
        case 'taishoku':
          settings.value.taishoku = detail
          break
        default:
          throw new Error(`unknown idPrefix: ${idPrefix}`)
      }
    }

    const onUpdateFukuri = (panelName: string, settingItem: ResponseSettingItem) => {
      settings.value.fukuri = settingItem
    }

    const onClickRegister = async () => {
      loading.value = true
      isSucceedRequest.value = false
      onDismissAlert()
      await callApiWrapper(requestError, async () => {
        await repository.save(settings.value)
        settings.value = await repository.list()
        isSucceedRequest.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedRequest.value = false
      requestError.value = null
    }

    return {
      loading,
      isSucceedRequest,
      requestError,
      settings,
      onUpdateTab,
      onUpdateFukuri,
      onClickRegister,
      onDismissAlert
    }
  }
})
